










































import { Component, Vue, Watch } from 'vue-property-decorator';

@Component
export default class CreateUser extends Vue {

  private cookieContents: object = {};
  private userData = {
    firstname: "",
     lastname: "",
     userid: "",
     password: "",
  }

  private verifyPassword = "";
  private showPassword = false;
  private alertText = "";

  get passwordsMatch(): boolean {
    return this.userData.password === this.verifyPassword;
  }

  get passwordValid(): boolean {
    return this.userData.password != "";
  }

  get userIdValid(): boolean {
    return this.userData.userid.length >= 3;
  }

  get canSubmit(): boolean {
    return this.passwordsMatch && this.userIdValid && this.passwordValid;
  }

  get passwordInputType(): string {
    return this.showPassword ? 'text' : 'password';
  }

  @Watch('userData.userid')
  watchUserID() {
    this.alertText = "";
  }

  @Watch('userData.password')
  watchPassword() {
    this.alertText = "";
  }

  async createUser() {
    try {
      this.alertText = '';
      await this.$http.post(
        '/user',
        { 
          ...this.userData
        }
      );
    } catch (err) {
      this.alertText = err.response.data;
    }
  }
}
  
